import styled from 'styled-components';
import * as Styles from '../../utils/styleUtils';

import upDownArrows from '../../../../../images/editor/icons/spinnerUpDownnew.png';

export const TimeInputRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 2px;
`;

export const TimeInputWrapper = styled.div`
  && {
    flex-grow: 1;
    cursor: grab;
    ${Styles.SizeStyles}
    ${Styles.FontStyles}
    text-align: ${({ styleProps }) => styleProps?.textAlign || 'left'};
    padding: ${({ renderMode }) => (renderMode === 'mobile' ? '4px 8px' : '2px 4px')};
    ${Styles.BorderStyles}
  }
`;

export const TimeSegmentsContainer = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  height: 100%;
`;

export const TimeSegment = styled.div`
  flex: 1;
  text-align: center;
`;

export const SpinnerImage = styled.div`
  height: 25px;
  width: 16px;
  background-image: url(${upDownArrows});
  background-repeat: no-repeat;
  background-position: center;
  flex-shrink: 0;
`;